export default "__VITE_ASSET__yqP6GosV__"